import { useCallback, useEffect, useRef, useState } from "react";
import { debounce } from "lodash";
import { isEmpty } from "./helper";

/**
 * genera una lista di predizioni dell'indirizzo fornito
 * @param {string} input stringa di cui bisogna identificare l'indirizzo
 * @param types vettore di tipi es: ['hospital', 'pharmacy', 'bakery', 'country']
 * @returns {{addressPredictions:[{mainText, secondaryText}], isLoading:boolean}} vettore di predizioni e un flag che indica se c'è un caricamento
 */
export default function useAddressPredictions(input, types = []) {
    const [predictions, setPredictions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const sessionToken = useRef(new window.google.maps.places.AutocompleteSessionToken());

    async function getPlacePredictions(input) {
        if (isEmpty(input)) {
            setPredictions([]);
            setIsLoading(false);
            return;
        }

        try {
            const request = {
                input: input,
                sessionToken: sessionToken.current,
            };

            // Add types if provided
            if (types && types.length > 0) {
                request.includedPrimaryTypes = types;
            }

            const { suggestions } = await window.google.maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions(request);

            setPredictions(
                suggestions ?
                    suggestions.map(suggestion => {
                        return {
                            mainText: suggestion.placePrediction.mainText.text,
                            secondaryText: suggestion.placePrediction.secondaryText?.text || '',
                            placeId: suggestion.placePrediction.placeId
                        }
                    })
                    :
                    []
            );
            setIsLoading(false);
        } catch (error) {
            console.error('Error fetching place predictions:', error);
            setPredictions([]);
            setIsLoading(false);
        }
    }

    const debouncedGetPlacePredictions = useCallback(
        debounce(input => {
            getPlacePredictions(input)
        }, 500),
        []
    );

    useEffect(() => {
        setIsLoading(true);
        debouncedGetPlacePredictions(input);
    }, [input]);

    return { addressPredictions: predictions, isLoading };
}
